<template>
  <div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'OidcCallback',
  setup() {
    const store = useStore()
    const router = useRouter()

    store.dispatch('oidcStore/oidcSignInCallback')
      .then((redirectPath) => {

        let materialType = store.getters['filtersModule/getMaterialType']
        let oidcUser = store.getters['oidcStore/oidcUser']
        if (!oidcUser?.roles.includes('ROLE_PATIENT_COORDINATOR')) {
          store.dispatch('favouritesModule/fetchFavourites')
          for (let mode of ['own','partner']) {
            store.dispatch('phenotypeModule/fetchPhenotype', mode)
          }
          store.dispatch('cartModule/fetchCart')
          store.dispatch('cartModule/fetchCartConfig')
          store.dispatch('fileMTModule/fetchFiles')
          store.dispatch('reservationModule/clearPaymentReservations')
        }
        
        router.push(redirectPath).then(() => {
          if (redirectPath.includes('/results')) {
            window._hsq = window._hsq || []
            window._hsq.push(['identify',{ email: oidcUser.email }])
            window._hsq.push([
              'trackCustomBehavioralEvent',
              {
                name: process.env.VUE_APP_HS_SEARCH_MATERIAL_TYPE_EVENT_NAME,
                properties: {
                  material_type: materialType
                }
              },
            ])
          }
        })
      })
      .catch((err) => {
        console.error(err)
        router.push({name: "search"})
      })
  }
}
</script>